module.exports = __webpack_public_path__ + "static/media/merch.4232c80d.jpg";